<template>
  <div class="entry">
    <div class="sift">
      <div class="title">报表查询</div>
      <div class="inquire">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" size="small">
          <el-form-item>
            <strong slot="label">名称</strong>
            <el-input
              v-model="formInline.name"
              placeholder="请输入名称"
              clearable
              @keyup.enter.native="inquire"
              @clear="inquire"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <strong slot="label">代码</strong>
            <el-input
              v-model="formInline.code"
              placeholder="请输入代码"
              clearable
              @keyup.enter.native="inquire"
              @clear="inquire"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <strong slot="label">报表类型</strong>
            <el-select v-model="formInline.repttype" placeholder="请选择报表类型" clearable filterable @change="inquire">
              <el-option v-for="(item, index) in dropDown.reptType" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="inquire" style="background:#0C75E5">查询</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <div class="title">报表列表</div>
      <el-button type="primary" plain icon="el-icon-plus" @click="handleAdd" size="small">新建</el-button>
      <el-button icon="el-icon-edit-outline" plain type="success" :disabled="!edit" @click="handleEdit" size="small">编辑</el-button>
      <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="!del" @click="handleDel">删除</el-button>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="code" label="代码"></el-table-column>
        <el-table-column prop="name" label="名称">
          <template slot-scope="scope">
            <a @click="handleDetail(scope.row)" class="link">{{scope.row.name}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="repttype" label="类型" align="center">
          <template slot-scope="scope">
            <DictTag :options="dropDown.reptType" :value="scope.row.repttype"/>
          </template>
        </el-table-column>
        <el-table-column prop="qjqm" label="期间类型" align="center">
          <template slot-scope="scope">
            <DictTag :options="dropDown.qjqmType" :value="scope.row.qjqm"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              icon="el-icon-edit"
              @click.native.stop="handleEdit(scope.row)"
              type="text"
            >编辑
            </el-button>
            <el-button
              size="mini"
              icon="el-icon-delete"
              @click.native.stop="handleDel(scope.row)"
              type="text"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="pageSize"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog v-dialog-drag
      :title="title"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="70px"
        class="demo-ruleForm"
        label-position="right"
      >
        <el-form-item label="名称" prop="name">
          <el-input type="text" v-model="ruleForm.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="repttype">
          <el-select v-model="ruleForm.repttype" placeholder="请选择类型" style="width:100%">
            <el-option v-for="(item, index) in dropDown.reptType" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="期间类型" prop="qiqm">
          <el-select v-model="ruleForm.qjqm" placeholder="请选择期间类型" style="width:100%">
            <el-option v-for="(item, index) in dropDown.qjqmType" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import DictTag from '@/components/DictTag.vue'
import { mapState } from 'vuex'
import handleTree from '@/utils/handleTree'
import getCurrentDate from '@/utils/getCurrentDate'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import qs from 'qs'
  export default {
    components: {
      DictTag,
      Treeselect,
    },
    computed: {
      ...mapState ({
        dropDown: state => state.dropDown.dropDown
      })
    },
    data() {
      return {
        tableData: [],
        loading: true,
        dialogFormVisible: false,
        formInline: {
          name: '',
          code: '',
          repttype: '',
          qjqm:'',
          nbzzId: JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).nbzzId : -1
        },
        ruleForm: {
          name: "",
          repttype: '',
          qjqm:''
        },
        rules: {
          name: [{ required: true, message: "请输入名称", trigger: "submit" }],
          repttype: [{ required: true, message: "请选择类型", trigger: "submit" }]
        },
        // options: [],
        // 弹出层标题
        title: '',
        isLoading: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        // 编辑按钮不可点
        edit: false,
        del: false,
        list: [],
        itemList: [], // 项目列表
        cbSubjectList: [], // 科目列表
        options: [], // 树选项
        ofrthingList: [],
        cashList: [], // 现金列表
      }
    },
    created () {
      this.getList()
      this.getData()
    },
    methods: {
      // 查询按钮
      inquire() {
        this.loading = true
        this.pageNum = 1
        this.getList()
      },
      // 重置按钮
      reset() {
        for(let key in this.formInline) {
          if(key !== 'nbzzId') {
            this.formInline[key] = ""
          }
        }
        this.loading = true
        this.pageNum = 1
        this.getList()
      },
      getList() {
        // 获取报表类型下拉
        if(!this.dropDown.reptType){
          this.$http.get(url.getDataList, {params: {type: 'buss_rept_type'}}).then(res => {
            if(res.data.code == 200) {
              this.$store.commit('setReptType', res.data.data)
            }
          })
        }
        if(!this.dropDown.qjqmType){
          this.$http.get(url.getDataList, {params: {type: 'buss_qjqm_type'}}).then(res => {
            if(res.data.code == 200) {
              this.$store.commit('setQjqmType', res.data.data)
            }
          })
        }
        this.$http.get(url.cffreptList, {params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.formInline
        }}).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            this.tableData = res.data.data.list
            this.total = res.data.data.total
          }
        })
      },
      handleAdd() {
        this.dialogFormVisible = true
        this.title = '新增报表'
        this.$nextTick(() => {
          // 清除表单校验效果
          this.$refs.ruleForm.clearValidate();
        })
        // console.log(itemList.length == 0 || cbSubjectList.length == 0);
        for(let key in this.ruleForm) {
          this.ruleForm[key] = ''
        }
        this.ruleForm.nbzzId = this.formInline.nbzzId
      },
      // 提交表单
      submitForm(formName) {
        // console.log(formName);
        // console.log(this.$refs);
        // console.log(this.$refs[formName]);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            // console.log(this.ruleForm);
            if(!this.ruleForm.cfReptId) { // 新增报表
              this.$http.post(url.addRept, qs.stringify(this.ruleForm)).then(res => {
                this.isLoading = false
                if(res.data.code === 200) {
                  this.$message.success(res.data.msg);
                  this.dialogFormVisible = false;
                  this.pageNum = 1
                  this.loading = true
                  this.getList()
                }
              })
            }else { // 修改报表
              this.$http.post(url.editRept, qs.stringify(this.ruleForm)).then(res => {
                this.isLoading = false
                if(res.data.code === 200) {
                  this.$message.success(res.data.msg);
                  this.dialogFormVisible = false;
                  this.pageNum = 1
                  this.loading = true
                  this.getList()
                }
              })
            }
          } else {
            return false;
          }
        });
      },
      handleDetail(row) {
        this.$router.push('/accounting/mReport/' + row.cfReptId + '/' + this.formInline.nbzzId)
        let obj = {
          path: '/accounting/mReport/' + row.cfReptId + '/' + this.formInline.nbzzId,
          name: 'mReportDetail',
          label: '报表内容',
          offOjdtId: row.cfReptId,
          children: []
        }
        this.$store.commit("selectMenu", obj);
      },
      handleEdit(row) {
        if(this.$refs.ruleForm) {
          this.$nextTick(() => {
            // 清除表单校验效果
            this.$refs.ruleForm.clearValidate();
          })
        }
        // if(this.itemList.length == 0 || this.cbSubjectList.length == 0){
        //   // console.log(11111111);
        //   this.getData()
        // }
        const id = row.cfReptId || this.ids[0]
        this.dialogFormVisible = true
        this.title = '修改报表'
        this.$http.get(url.getRept, {params: {cfReptId: id}}).then(res => {
          if(res.data.code === 200) {
            this.ruleForm = res.data.data
          }
        })
      },
      handleDel(row) {
        const id = row.cfReptId || this.ids.toString()
        this.$confirm('此操作将永久删除该报表, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(url.deleteRept, qs.stringify({cfReptId: id})).then(res => {
            if(res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.pageNum = 1
              this.loading = true
              this.getList()
            }
          })

        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      },
      handleSelectionChange(rows) {
        this.ids = rows.map(item => item.cfReptId)
        this.edit = rows.length === 1
        this.del = rows.length >= 1
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.pageNum = 1
        this.loading = true
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.loading = true
        this.getList()
      },
      // 小于10补0
      add0(n) {
        return n < 10 ? '0' + n : n
      },
      getData() {
        this.$http.get(url.getAllItemList).then(res => {
          this.itemList = res.data.data
        })
        this.$http.get(url.getCbSubjectList,{params:{nbzzId:this.formInline.nbzzId}}).then(res => {
          this.cbSubjectList = handleTree(res.data.data, 'cbSubjectId', 'pid')
        })
        this.$http.get(url.getPostAndUserList).then(res => {
          this.ofrthingList = res.data.data
        })
        this.$http.get(url.getCashList).then(res => {
          this.cashList = res.data.data
        })
      },
      /** 转换数据结构 */
      normalizer(node) {
        // this.$nextTick(() => {
        //   if (node.children && !node.children.length) {
        //   delete node.children;
        // }
        return {
          id: node.cbSubjectId,
          label: node.subjectName + ': ' + node.subjectNumber,
          children: node.children
        };
        // })
      },
    },
  }
</script>

<style lang="scss" scoped>
.entry {
  /* padding: 16px; */
  .sift, .main {
    background: #FFFFFF;
    box-shadow: 2px 3px 8px 0px rgba(208,208,208,0.5);
    border-radius: 11px;
    padding: 16px;
    position: relative;
    /* margin-bottom: 16px; */
    .add{
      margin-bottom: 16px;
    }
    .el-table {
      margin-top: 16px;
      margin-bottom: 39px;
    }
  }
  .sift {
    margin-bottom: 16px;
  }
  .title {
    height: 14px;
    font-size: 14px;
    font-family: STHeitiSC-Medium, STHeitiSC;
    font-weight: 500;
    color: #282828;
    line-height: 14px;
    padding-left: 8px;
    border-left: #0c75e5 2px solid;
    margin-bottom: 16px;
    font-weight: bolder;
  }
}
</style>
